import React from 'react';
import {  
  Container,
  Paper,
  TextField,
  Grid,
  Card,
  CardActions,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
  Button,
  InputLabel,
  Select,
  MenuItem,
  CssBaseline,
  Dialog,
  DialogTitle
} from '@material-ui/core';
import {
  LinkedIn,
  Info,
} from '@material-ui/icons';


const SHEET_KEY = '180jdTCVUaW8Ld1h-IE4vsyJfNEJXBuaX-plizCgAo08';

const FilterBox = (props) => {
  return (
    <Paper style={{padding: 12, margin: 6}}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <InputLabel id="search">Search Members</InputLabel>
          <TextField 
            fullWidth
            value={props.filterValue} 
            onChange={(e)=>props.filter(e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <InputLabel id="department">Department</InputLabel>
          <Select
            fullWidth
            value={props.selectedDepartment}
            onChange={(e) => props.filterDepartment(e.target.value)}
          >
            {
              props.departments.map(department => (
                <MenuItem key={department} value={department}>{department}</MenuItem>
              ))
            }
          </Select>
        </Grid>
      </Grid>
    </Paper>
  )
}

const BioDialog = (props) => {
  const { currentMember } = props;
  return (
    <Dialog
      open={props.open}
      onClose={props.closeBioDialog}
    >
      <DialogTitle id="bio-title">{currentMember.name}</DialogTitle>
      <Grid container style={{padding: 14, textAlign: 'center'}} spacing={3}>
        <Grid item xs={12}>
          <img 
            style={{
              width: '75%',
              borderRadius: '50%',
              display: 'block',
              marginLeft: 'auto',
              marginRight: 'auto',
            }} 
            src={currentMember.picture} 
            alt={currentMember.name}
          />
        </Grid>
        <Grid item xs={12}>
          <Typography variant="subtitle1" color="textSecondary" component="p">
            {currentMember.title ? currentMember.title.toUpperCase() : null} {currentMember.department ? ('| ' + currentMember.department.toUpperCase()) : null}
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Typography variant="body1" color="textPrimary" component="p">
            {currentMember.bio}
          </Typography>
        </Grid>
      </Grid>
    </Dialog>
  )
}

const MemberCard = (props) => {
  return (
    <Card style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'space-between'}}>
      {props.picture && (
        <CardMedia
          style={{height: 0, paddingTop: '100%'}}
          image={props.picture}
          title={props.name}
        />
      )}
      <CardContent>
        <Typography style={{paddingBottom: 0}} gutterBottom variant="h5" component="h2">
          {props.name}
        </Typography>
        <Typography style={{paddingBottom: 0}} variant="subtitle1" component="p">
          {props.title}
        </Typography>
        <Typography style={{paddingBottom: 0}} variant="subtitle2" color="textSecondary" component="p">
          {props.department ? props.department.toUpperCase() : null}
        </Typography>
      </CardContent>
      <CardActions>
        <Button
          disabled={!props.bio}
          startIcon={<Info />}
          onClick={()=>props.openBioDialog(props)}>
          Bio
        </Button>
        <Button 
          disabled={!props.linkedin}
          target="_blank" 
          startIcon={<LinkedIn />}
          href={props.linkedin}>
            LinkedIn
        </Button>
        </CardActions>
    </Card>
  )
}

const DirectoryList = (props) => {
  // console.log("updated directory: ", props.directory);
  return (
    <div style={{padding: 12, margin: 6}}>
      <Grid container spacing={3}>
      {props.directory.map((member, i) => {
        const key = member.email === 'null' ? i : member.email;
        // console.log("key: ", key);
        return (
            <Grid key={key} item xs={12} sm={4} lg={3}>
              <MemberCard 
                email={member.email} 
                name={member.first + ' ' + member.last} 
                picture={member.picture}
                linkedin={member.linkedin}
                title={member.title}
                department={member.department}
                bio={member.bio}
                openBioDialog={props.openBioDialog}
              />
            </Grid>
        )
      })}
     </Grid>
    </div>
  )
}

class DirectoryApp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingMembers: false,
      directory: [],
      filteredDirectory: [],
      filterValue: "",
      departments: [],
      selectedDepartment: "",
      bioDialogOpen: false,
      currentMember: {},
    };
  }
  componentDidMount = () => {
    this.fetchDirectory();
  }

  // Return array of string values, or NULL if CSV string not well formed.
  CSVtoArray = (text) => {
    var re_valid = /^\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*(?:,\s*(?:'[^'\\]*(?:\\[\S\s][^'\\]*)*'|"[^"\\]*(?:\\[\S\s][^"\\]*)*"|[^,'"\s\\]*(?:\s+[^,'"\s\\]+)*)\s*)*$/;
    var re_value = /(?!\s*$)\s*(?:'([^'\\]*(?:\\[\S\s][^'\\]*)*)'|"([^"\\]*(?:\\[\S\s][^"\\]*)*)"|([^,'"\s\\]*(?:\s+[^,'"\s\\]+)*))\s*(?:,|$)/g;
    // Return NULL if input string is not well formed CSV string.
    if (!re_valid.test(text)) return null;
    var a = [];                     // Initialize array to receive values.
    text.replace(re_value, // "Walk" the string using replace with callback.
        function(m0, m1, m2, m3) {
            // Remove backslash from \' in single quoted values.
            if      (m1 !== undefined) a.push(m1.replace(/\\'/g, "'"));
            // Remove backslash from \" in double quoted values.
            else if (m2 !== undefined) a.push(m2.replace(/\\"/g, '"'));
            else if (m3 !== undefined) a.push(m3);
            return ''; // Return empty string.
        });
    // Handle special case of empty last value.
    if (/,\s*$/.test(text)) a.push('');
    return a;
  };

  fetchDirectory = async () => {
    this.setState({isLoadingDirectory: true});

    // let fullUrl = `https://spreadsheets.google.com/feeds/list/${SHEET_KEY}/od6/public/values?alt=json`;
    // let result = await fetch(fullUrl);
    // let data = await result.json();

    // new api
    let fullUrl = `https://docs.google.com/spreadsheets/d/e/2PACX-1vRbqgRQSOZg8cdTSaqWIlAA1C2y4JnQ5iacpGoNNWpu7Vj7FCqw56aOyVfz_OI3y0HqWhiIUAGu0oiJ/pub?gid=0&single=true&output=csv`;
    let result = await fetch(fullUrl);
    let data = (await result.text()).split("\n");
    // console.log(data);

    let directoryArr = [];
    let departmentArr = [];
    let emailArr = [];
    // for(let i = 0; i < data.feed.entry.length; i++) {
    //   let member = data.feed.entry[i];
    //   if (!emailArr.includes(member.gsx$email.$t)) {
    //     emailArr.push(member.gsx$email.$t);
    //     directoryArr.push({
    //       first: member.gsx$first.$t,
    //       last: member.gsx$last.$t,
    //       email: member.gsx$email.$t,
    //       picture: member.gsx$picture.$t,
    //       linkedin: member.gsx$linkedin.$t,
    //       title: member.gsx$title.$t,
    //       department: member.gsx$department.$t,
    //       bio: member.gsx$bio.$t,
    //     })
    //     if (!departmentArr.includes(member.gsx$department.$t)) {
    //       departmentArr.push(member.gsx$department.$t)
    //     }
    //   }
    // }
    let headerKeys = {};
    data[0].split(',').map((header, i) => {
      headerKeys[header] = i;
    });
    // console.log("headerKeys: ", headerKeys);

    for(let i = 1; i < data.length; i++) {
      let member = this.CSVtoArray(data[i]);
      if (member === null) {
        continue;
      }
      // console.log(member);
      if (!emailArr.includes(member[2])) {
        emailArr.push(member[2]);
        directoryArr.push({
          first: member[0],
          last: member[1],
          email: member[2],
          picture: member[3],
          linkedin: member[4],
          title: member[5],
          department: member[6],
          bio: member[7],
        })
        if (!departmentArr.includes(member[6])) {
          departmentArr.push(member[6])
        }
      }
    }
    departmentArr.push('[ALL]')
    departmentArr.sort();
    // console.log(departmentArr);
    // console.log(directoryArr);

    this.setState({
      isLoadingDirectory: false,
      directory: directoryArr,
      filteredDirectory: directoryArr,
      departments: departmentArr,
    })
  }

  filter = (filter) => {
    this.setState({filterValue: filter});
    this.combinedFilter(this.state.selectedDepartment, filter)
  }

  filterDepartment = (department) => {
    this.setState({selectedDepartment: department});
    this.combinedFilter(department, this.state.filterValue)
  }

  combinedFilter = (department, filter) => {
    let newDirectory = this.state.directory.slice();

    // do department filter first
    if (department !== '[ALL]') {
      department = department.toLowerCase();
      newDirectory = newDirectory.filter(member => {
        if (member.department.toLowerCase().includes(department)) {
          return true;
        }
        else {
          return false;
        }
      })
    }
    // now general filter
    newDirectory = newDirectory.filter(member => {
      if (member.first.toLowerCase().includes(filter)) {
        return true;
      }
      else if(member.last.toLowerCase().includes(filter)) {
        return true;
      }
      else if(member.email.toLowerCase().includes(filter)) {
        return true;
      }
      else {
        return false;
      }
    })

    // console.log(newDirectory);

    this.setState({
      filteredDirectory: newDirectory
    });

  }

  openBioDialog = (memberProps) => {
    // console.log("openeing bio dialog", memberProps);
    this.setState({
      currentMember: memberProps,
      bioDialogOpen: true,
    })
  }

  closeBioDialog = () => {
    this.setState({
      currentMember: {},
      bioDialogOpen: false,
    })
  }

  render () {
    return (
      <React.Fragment>
        <Container>
          <CssBaseline />
          <BioDialog
            open={this.state.bioDialogOpen}
            closeBioDialog={this.closeBioDialog}
            currentMember={this.state.currentMember}
          />
          <FilterBox
            filterValue={this.state.filterValue}
            filter={this.filter}
            departments={this.state.departments}
            selectedDepartment={this.state.selectedDepartment}
            filterDepartment={this.filterDepartment}
          />
          <DirectoryList
            directory={this.state.filteredDirectory}
            openBioDialog={this.openBioDialog}
            closeBioDialog={this.closeBioDialog}
          />
        </Container>
      </React.Fragment>
    )
  }
}

export {DirectoryApp};